import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { renderFormattedText } from "Lib/text-utils";
import styles from "Styles/CompanySize.module.css";
import halfCircle from "Assets/vectors/half-circle.svg";

const NurturingApproachInfoContent = ({ heading }) => {
  return (
    <InfoContentMotionWrapper>
      <h3 className={styles.heading}>{renderFormattedText(heading)}</h3>
      <img
        className={`${styles.decorativeElements} ${styles.halfCircle}`}
        src={halfCircle}
        alt="half circle"
      />
    </InfoContentMotionWrapper>
  );
};

export default NurturingApproachInfoContent;
